// Query keys for a maker's own liquidity program data. `all` scopes invalidation and the logout
// clear. Every entry is keyed by the signed-in user: the endpoints read the caller from the
// credential and take no user parameter, so without the id in the key the next account in the tab
// would be served the previous one's cached programs and coverage. The coverage entry is also keyed
// by its window, because a different window is a different response, not a stale version of it.
export const liquidityProgramCoverageKeys = {
    all: ['liquidityProgramCoverage'] as const,
    programs: (userId: string) => [...liquidityProgramCoverageKeys.all, userId, 'programs'] as const,
    coverage: (userId: string, trackId: string | undefined, startTs: number, endTs: number) =>
        [...liquidityProgramCoverageKeys.all, userId, 'coverage', trackId ?? 'all', startTs, endTs] as const,
};
